import type { ImageDto, MessageEventDto } from "@/api/types";
import { DatedAnnouncementDetails } from "@/components/EntityPreview/DatedAnnouncementDetails";
import { EventPreviewCard } from "@/components/EntityPreview/EventPreviewCard";
import { useSessionUser } from "@/hooks/Network/useSessionUser";
import { useSlug } from "@/hooks/useSlug";
import { routes } from "@/routes";

export function CommunityMessageEvent({
  event,
  title,
  image,
}: {
  event: MessageEventDto;
  title: string;
  image?: ImageDto;
}): React.ReactNode {
  const slug = useSlug();
  const sessionUser = useSessionUser();
  if (event.allowsRegistration) {
    return (
      <EventPreviewCard
        href={routes.events.details({ slug, id: event.id })}
        title={title}
        startsAt={event.startsAt}
        endsAt={event.endsAt}
        location={event.location}
        image={image}
        fallbackImage={sessionUser.project.backgroundImage}
      />
    );
  }

  return <DatedAnnouncementDetails startsAt={event.startsAt} endsAt={event.endsAt} location={event.location} />;
}
